<div>
  <label class="switch">
    <input
      type="checkbox"
      [checked]="isChecked"
      [disabled]="disabled"
      (change)="onToggle()"
    />
    <span class="slider"></span>
  </label>
</div>